import { SHOW_TOAST_MESSAGE } from './actionTypes';

export default (message, type = 'success', iconType) => ({
  type: SHOW_TOAST_MESSAGE,
  payload: {
    type,
    message,
    iconType
  }
});